import { GridTemplateValue } from '@billy/design-system'

import { InvoiceDiscountMode } from '@features/invoices/enums/invoiceDiscountMode'

import {
  DEMO_INVOICE_LINE_COLUMNS_TEMPLATE,
  DEMO_INVOICE_LINE_COLUMNS_TEMPLATE_WITH_DISCOUNT,
} from '../constants/demoInvoiceLineColumnsTemplate'

export const getDemoInvoiceLineColumnsTemplate = (discountMode: InvoiceDiscountMode): GridTemplateValue[] =>
  discountMode === InvoiceDiscountMode.ByItem
    ? DEMO_INVOICE_LINE_COLUMNS_TEMPLATE_WITH_DISCOUNT
    : DEMO_INVOICE_LINE_COLUMNS_TEMPLATE
